import React from 'react';
import Hero from './Hero';
import Charity from './Charity';
import Product from './Product';

const Home = ({ onAddToCart }) => {
  return (
    <>
      <Hero />
      <Charity />
      <Product onAddToCart={onAddToCart} />
    </>
  );
};

export default Home;
